import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import {
  CHANGE_PASSWORD,
  ChangePasswordAction,
  GET_USER_PROFILE,
  GetUserProfileAction,
  UPDATE_USER_PROFILE,
  UPLOAD_USER_PROFILE_PHOTO,
  UpdateUserProfileAction,
  UploadUserProfilePhotoAction,
} from "./actionTypes";

import {
  changePassword,
  getUserProfile,
  updateUserProfile,
  uploadUserProfilePhoto,
} from "../../helpers/backend_helper";
import {
  changePasswordError,
  changePasswordSuccess,
  getUserProfileError,
  getUserProfileSuccess,
  updateUserProfileError,
  updateUserProfileSuccess,
  uploadUserProfilePhotoError,
  uploadUserProfilePhotoSuccess,
} from "./actions";

function* getUserProfileSaga({ payload: {} }: GetUserProfileAction) {
  try {
    const response: ResponseGenerator = yield call(getUserProfile);
    yield put(getUserProfileSuccess(response.data));
  } catch (error) {
    yield put(getUserProfileError(error));
  }
}

function* updateUserProfileSaga({
  payload: { request, history },
}: UpdateUserProfileAction) {
  try {
    const response: ResponseGenerator = yield call(updateUserProfile, request);
    yield put(updateUserProfileSuccess(response.data));
  } catch (error) {
    yield put(updateUserProfileError(error));
  }
}

function* uploadUserProfilePhotoSaga({
  payload: { file },
}: UploadUserProfilePhotoAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadUserProfilePhoto,
      file
    );
    yield put(uploadUserProfilePhotoSuccess(response.data));
  } catch (error) {
    yield put(uploadUserProfilePhotoError(error));
  }
}

function* changePasswordSaga({ payload: { request } }: ChangePasswordAction) {
  try {
    yield call(changePassword, request);
    yield put(changePasswordSuccess());
  } catch (error) {
    yield put(changePasswordError(error));
  }
}

function* AccountSaga() {
  yield takeEvery(GET_USER_PROFILE, getUserProfileSaga);
  yield takeEvery(UPDATE_USER_PROFILE, updateUserProfileSaga);
  yield takeEvery(UPLOAD_USER_PROFILE_PHOTO, uploadUserProfilePhotoSaga);
  yield takeEvery(CHANGE_PASSWORD, changePasswordSaga);
}

export default AccountSaga;
